

export const ActionName = {
    AddDeposit : "AddDeposit",
    AddPayment : "AddPayment",
    AddRequest : "AddRequest",
    BeneficiaryInfo : "Beneficiary Info",
    DealVersions : "Deal Versions",
    EditBeneficiaryInfo: 'EditBeneficiaryInfo',
    EditCustomerInfo : "EditCustomerInfo",
    EditOutgoingExpiryDeals: "EditOutgoingExpiryDeals",
    ShowBeneficiaryInfo: 'ShowBeneficiaryInfo',
    ShowBNOrderInfoForDelivery: 'ShowBNOrderInfoForDelivery',
    ShowBNOrderInfoForPickUp: 'ShowBNOrderInfoForPickUp',
    ShowComplaintInfo: 'ShowComplaintInfo',
    ShowCountryAdditionalSettings: "ShowCountryAdditionalSettings",
    ShowCustomerInfo : 'ShowCustomerInfo',
    ShowCustomerPaymentScreen: "ShowCustomerPaymentScreen",
    ShowDealInfo : "ShowDealInfo",
    ShowDealInfoScreen : "ShowDealInfoScreen",
    ShowDepositInfo : 'ShowDepositInfo',
    ShowOtherSettlementFunds: "ShowOtherSettlementFunds",
    ShowOutgoingFundsScreen: "ShowOutgoingFundsScreen",
    ShowPaymentInfo : "ShowPaymentInfo",
    ShowSettlementInfo: 'ShowSettlementInfo',
    ShowSettlementScreen: 'ShowSettlementScreen',
    ShowUnpaidOrder: 'ShowUnpaidOrder'
}
